import React from 'react';
import { Progress, Card, CardBody } from 'reactstrap';
import moment from 'moment';
import { useKioskGamification } from '../../../../Kiosk/hooks/useKioskGamification';

const ProfileEvaluation = ({ member }) => {
    // Reutilizando o hook do Kiosk, que já traz latestEvaluation e groupedCriteria formatadinhos
    const {
        latestEvaluation,
        groupedCriteria,
        loadingEval
    } = useKioskGamification(member);

    if (loadingEval) {
        return (
            <div className="d-flex justify-content-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Carregando avaliação...</span>
                </div>
            </div>
        );
    }

    if (!latestEvaluation) {
        return (
            <Card className="border-0 shadow-sm mt-3 rounded-0">
                <CardBody className="d-flex flex-column align-items-center justify-content-center text-muted text-center p-5" style={{ minHeight: "200px" }}>
                    <h5 className="fw-bold text-dark">Nenhuma Avaliação</h5>
                    <p className="mb-0">Não encontramos avaliações recentes registradas para este aluno.</p>
                </CardBody>
            </Card>
        );
    }

    return (
        <Card className="border-0 shadow-sm mt-3 rounded-0">
            <CardBody className="p-4">
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <div>
                        <h5 className="mb-0 fw-bold text-dark">{latestEvaluation.eventName || "Avaliação Técnica"}</h5>
                        <p className="text-muted mb-0 small">
                            <i className="mdi mdi-calendar-blank me-1"></i>
                            {moment(latestEvaluation.date).format("DD/MM/YYYY")}
                        </p>
                    </div>
                    <div className="text-end">
                        <span className={`badge rounded-0 px-3 py-2 ${latestEvaluation.status === "PASSED" ? "bg-success text-white" : "bg-warning text-dark"} shadow-sm`}>
                            {latestEvaluation.status === "PASSED" ? (
                                <><i className="mdi mdi-check-circle me-1"></i> Aprovado</>
                            ) : (
                                <><i className="mdi mdi-clock-outline me-1"></i> Em Progresso</>
                            )}
                        </span>
                    </div>
                </div>

                <div className="mb-4">
                    <div className="d-flex justify-content-between align-items-center mb-2">
                        <span className="fw-bold text-dark">Progresso para o próximo nível</span>
                        <span className="fw-bold text-primary">{latestEvaluation.progressPercent || 0}%</span>
                    </div>
                    <Progress value={latestEvaluation.progressPercent || 0} color="primary" style={{ height: "10px", backgroundColor: "rgba(0,0,0,0.1)" }} />
                </div>

                {Object.keys(groupedCriteria).length > 0 && (
                    <div className="mt-4">
                        <h6 className="fw-bold text-secondary mb-3 text-uppercase" style={{ fontSize: "0.85rem", letterSpacing: "1px" }}>Critérios Avaliados</h6>
                        <div className="table-responsive">
                            <table className="table table-borderless mb-0 bg-transparent">
                                <tbody>
                                    {Object.entries(groupedCriteria).map(([objectiveName, criteriaList], objIdx) => (
                                        <React.Fragment key={objIdx}>
                                            <tr className="border-0">
                                                <td colSpan="2" className="pt-4 pb-2 px-0 bg-transparent">
                                                    <div className="fw-bold text-dark mb-0" style={{ borderLeft: "4px solid #f1b44c", paddingLeft: "10px", fontSize: "1.1rem" }}>
                                                        {objectiveName}
                                                    </div>
                                                </td>
                                            </tr>
                                            {criteriaList.map((criterion, idx) => {
                                                const uniqueId = `crit-${objIdx}-${idx}`;
                                                return (
                                                    <tr key={uniqueId} style={{ borderBottom: "1px solid rgba(0,0,0,0.05)" }}>
                                                        <td className="py-2 px-0 bg-transparent align-middle" style={{ width: '60%' }}>
                                                            <div className="d-flex align-items-center">
                                                                <div 
                                                                    className="fw-semibold text-dark text-truncate d-inline-block"
                                                                    style={{ maxWidth: criterion.isFundamental ? 'calc(100% - 40px)' : '100%' }}
                                                                    title={criterion.name}
                                                                >
                                                                    {criterion.name}
                                                                </div>
                                                                {criterion.isFundamental && (
                                                                    <span className="badge bg-danger-subtle text-danger font-size-10 ms-2" title="Fundamental">Fund.</span>
                                                                )}
                                                            </div>
                                                        </td>
                                                        <td className="py-2 text-end px-0 align-middle bg-transparent" style={{ width: '40%' }}>
                                                            <span className="fw-bold px-3 py-1 rounded-0 text-dark border border-secondary border-opacity-25 text-truncate d-inline-block" style={{ maxWidth: '100%' }}>
                                                                {criterion.levelName || "Avaliado"}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}

                {latestEvaluation.observations && (
                    <div className="mt-4 p-3 rounded-0 text-muted border border-secondary border-opacity-25" style={{ backgroundColor: 'rgba(0,0,0,0.02)' }}>
                        <strong className="d-block mb-1 text-dark">Observações:</strong>
                        {latestEvaluation.observations}
                    </div>
                )}
            </CardBody>
        </Card>
    );
};

export default ProfileEvaluation;
